import { TariffFilterComponent, TariffFilterOutput } from '../../core/components/table/filter-panel/filters/tariff-filter/tariff-filter.component';
import { CommonModule, NgIf } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  ConfigurationProgressStatus,
  ConfigurationStatus,
  MeterDataOut,
  MeterGetAllDataIn,
  PageInfo,
  PermissionsEnum,
  SortingType,
} from '../../../api/api-reference';
import { DeviceSetupComponent } from '../../../device-setup/device-setup.component';
import { AuthService } from '../../../services/auth.service';
import { SignalRService } from '../../../services/signalr.service';
import { FutureDatepickerComponent } from '../../core/components/future-datepicker/future-datepicker.component';
import { SearchComponent } from '../../core/components/search/search.component';
import { SortComponent } from '../../core/components/sort/sort.component';
import {
  ShowHideColumnsComponent,
} from '../../core/components/table/show-hide-columns/show-hide-columns.component';
import { DateRangeInput } from '../../core/models/date-range-input';
import { PaginationComponent } from '../../core/components/pagination/pagination.component';
import { ClipboardService } from '../../../services/clipboard.service';
import { Column } from '../../core/models/column';
import { processDateRange } from '../../../helper/date-utils';
import { ConfirmDialogComponent } from '../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-tariff-management',
  standalone: true,
  imports: [
    TranslateModule,
    SearchComponent,
    FutureDatepickerComponent,
    NgIf,
    CommonModule,
    HttpClientModule,
    PaginationComponent,
    TariffFilterComponent,
    ShowHideColumnsComponent,
    SortComponent,
    RouterOutlet,
    DeviceSetupComponent,
    RouterLink,
    ConfirmDialogComponent
  ],
  providers: [Client],
  templateUrl: './tariff-management.component.html',
  styleUrl: './tariff-management.component.scss',
})
export class TariffManagementComponent {
  // Expose enum to template
  
  
  filtersApplied = 0;
  selectedFilters: SelectedFilters = {
    meterMakes: [],
    assetTypes: [],
    configurationStatuses: [],
    // Tariff specific filters
    customerTypes: [],
    tariffStatuses: [],
    tariffNameSearch: '',
  };
  dates: string = '';
  public currentPage: number = 1;
  public numberOfDevices: number = 0;
  public lastPageSize: number = 1;
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public selectedDevice: MeterDataOut | undefined;
  readonly dayInMs = 24 * 60 * 60 * 1000;
  isDeleteModalOpen = false;
  isBulkDeleteModalOpen = false;
  isBulkSetupModalOpen = false;
  selectedRow: MeterDataOut | null = null;
  public PermissionsEnum = PermissionsEnum;
  public ConfigurationStatus = ConfigurationStatus;
  isSetupModalOpen = false;
  selectedRows: string[] = [];

  data: MeterDataOut[] | undefined = [];
  requestData = new MeterGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    startDate: undefined,
    endDate: undefined,
    sorting: SortingType.Descending,
    meterMakes: [],
    assetTypes: [],
    configurationProgressStatus: [],
    meterModels: [],
    serviceTypes: [],
    areas: [],
    regions: []
  });

    columns: { header: string; key: keyof TariffDataOut }[] = [
    { header: 'TARRIFSETUP_TARIFF_CLASS_NAME', key: 'tariffClassName' },
    { header: 'TARIFFSETUP_RATE', key: 'tariffRate' },
    { header: 'TARRIFSETUP_TARIFF_CUSTOMER_TYPE', key: 'customerType' },
    { header: 'DEVICESETUP_SERVICETYPE', key: 'serviceType' },
    { header: 'TARRIFSETUP_TARIFF_DATE_CREATED', key: 'dateCreated' },
    { header: 'TARRIFSETUP_TARIFF_LAST_UPDATED', key: 'lastUpdated' },
    { header: 'TARRIFSETUP_TARIFF_STATUS', key: 'status' },
    { header: 'TARRIFSETUP_TARIFF_BAND', key: 'band' }
  ];

  constructor(
    private client: Client,
    public toastr: ToastrService,
    public authService: AuthService,
    private signalRService: SignalRService,
    public clipboardService: ClipboardService,
  ) {
    //this.selectedColumns = this.columns.slice(0, 10);
    this.reloadTable(1);
  }

  @ViewChild(FutureDatepickerComponent) datepicker!: FutureDatepickerComponent;
  @ViewChild(ShowHideColumnsComponent)
  showHideColumnsComponent!: ShowHideColumnsComponent;
  selectedColumns: Column[] = [];
  isDatepickerOpen = false;

  selectedDate: string | null = '';
  onDateRangeChanged(input: DateRangeInput): void {
    const result = processDateRange(input);

    this.requestData.startDate = result.startDate;
    this.requestData.endDate = result.endDate;
    this.selectedDate = result.selectedDate;
    this.filterDatesInTable();
  }

  clearDates(): void {
    this.requestData.startDate = undefined;
    this.requestData.endDate = undefined;
    this.reloadTable();
  }

  toggleModal() {
    this.isDatepickerOpen = !this.isDatepickerOpen;
  }

  filterDatesInTable() {
    // this.client.query(this.requestData).subscribe({
    //   next: (response) => {
    //     this.data = response.data;
    //     this.numberOfDevices = response.count || 0;
    //     this.lastPageSize = Math.ceil(this.numberOfDevices / this.pageSize);
    //   },
    //   error: (err) => {
    //     this.toastr.error(err);
    //   },
    // });
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  handleRowClick(row: MeterDataOut) {
    if (!this.isDeleteModalOpen) {
      this.selectedDevice = row;
    }
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;
    this.selectedDevice = undefined;

    // this.client.query(this.requestData).subscribe({
    //   next: (response) => {
    //     this.data = response.data;
    //     this.numberOfDevices = response.count || 0;
    //     this.lastPageSize = Math.ceil(this.numberOfDevices / this.pageSize);
    //     this.filtersApplied =
    //       (this.requestData.assetTypes?.length || 0) +
    //       (this.requestData.meterMakes?.length || 0) +
    //       (this.requestData.configurationProgressStatus?.length || 0);

    //     this.data?.forEach((meterData) => {
    //       if (meterData.meterInstallationDate) {
    //         meterData.meterInstallationDate = new Date(
    //           meterData.meterInstallationDate,
    //         );
    //       }
    //     });
    //   },
    //   error: (err) => {
    //     this.toastr.error(err);
    //   },
    // });
  }

  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }

  handleDelete(row: MeterDataOut) {
    this.selectedRow = row;
    this.isDeleteModalOpen = true;
  }

  confirmDelete(row: MeterDataOut) {
    this.client.deleteDevice(row.id).subscribe({
      next: () => {
        this.toastr.success('Device successfully deleted.');
        this.reloadTable(this.currentPage);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.isDeleteModalOpen = false;
    this.selectedRow = null;
  }

  cancelDelete() {
    this.isDeleteModalOpen = false;
    this.selectedRow = null;
  }

  confirmBulkDelete() {
    const rows = Array.from(this.selectedRows);
    this.client.bulkDelete(rows).subscribe({
      next: (r) => {
        this.toastr.success(r);
        this.selectedRows = [];
        this.reloadTable(this.currentPage);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.isBulkDeleteModalOpen = false;
  }

  onTariffDataReceived(event: TariffFilterOutput) {
    this.selectedFilters = {
      meterMakes: [],
      assetTypes: [],
      configurationStatuses: [],
      customerTypes: event.selectedCustomerTypes || [],
      tariffStatuses: event.selectedTariffStatuses || [],
      tariffNameSearch: event.tariffNameSearch || '',
    };
    
    // Apply tariff filters to your API request
    // Update your request data based on tariff filters
    // this.requestData.customerTypes = event.selectedCustomerTypes;
    // this.requestData.tariffStatuses = event.selectedTariffStatuses;
    // this.requestData.tariffNameSearch = event.tariffNameSearch;
    
    this.reloadTable();
  }

  onSortOption(selectedSort?: SortingType) {
    if (selectedSort) this.requestData.sorting = selectedSort;
    this.reloadTable();
  }

  updateColumns(columns: Column[]) {
    const fixedColumns = ['status', 'isConnected', 'configurationStatus'];
    const rest = columns.filter((col) => !fixedColumns.includes(col.key));
    const fixed = columns.filter((col) => fixedColumns.includes(col.key));
    this.selectedColumns = [...rest, ...fixed];
  }

  handleSetup(row: MeterDataOut) {
    if (this.authService.isAuthorized([PermissionsEnum.Device_configure])) {
      this.selectedRow = row;
      this.isSetupModalOpen = true;
    }
  }

  confirmSetup(row: MeterDataOut) {
    // this.client.setupDevice(row.id).subscribe({
    //   next: (r) => {
    //     this.toastr.success(r);
    //     this.reloadTable(this.currentPage);
    //   },
    //   error: (err) => {
    //     this.toastr.error(err);
    //   },
    // });
    // this.isSetupModalOpen = false;
    // this.selectedRow = null;
  }

  cancelSetup() {
    this.isSetupModalOpen = false;
    this.selectedRow = null;
  }

  bulkSetup() {
    // const rows = Array.from(this.selectedRows);
    // this.client.bulkSetup(rows).subscribe({
    //   next: (r) => {
    //     this.toastr.success(r);
    //     this.selectedRows = [];
    //     this.reloadTable(this.currentPage);
    //   },
    //   error: (err) => {
    //     this.toastr.error(err);
    //   },
    // });
    // this.isBulkSetupModalOpen = false;
    // this.isSetupModalOpen = false;
  }

  getImageTooltip(status: ConfigurationStatus) {
    if (
      status == ConfigurationStatus.InitialConfigurationFailed ||
      status == ConfigurationStatus.ReconfigurationFailed
    ) {
      return 'Device configuration failed. Click to configure.';
    }
    return 'Configuring device...';
  }

  closeWindow() {
    this.selectedDevice = undefined;
    this.isSetupModalOpen = false;
    this.reloadTable(this.currentPage);
  }

  isRowSelected(id: string) {
    return this.selectedRows?.some((item) => item == id);
  }

  toggleRowSelection(id: string) {
    if (this.isRowSelected(id)) {
      this.selectedRows = this.selectedRows?.filter((item) => item != id);
    } else {
      this.selectedRows?.push(id);
    }
  }

  toggleAllSelected(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      if (this.selectedRows.length <= 1000) {
        this.data!.forEach((obj) => {
          if (!this.isRowSelected(obj.id!)) {
            this.selectedRows.push(obj.id!);
          }
        });
      } else {
        this.toastr.warning(
          'You can select a maximum of 1000 entities for bulk actions.',
        );
      }
    } else {
      const dataIds = this.data!.map((obj) => obj.id!);
      this.selectedRows = this.selectedRows.filter(
        (id) => !dataIds.includes(id),
      );
    }
  }

  clear() {
    this.selectedRows = [];
  }

  isAllSelected() {
    return this.data!.every((obj) => this.isRowSelected(obj.id!));
  }
}

export interface SelectedFilters {
  meterMakes: string[];
  assetTypes: string[];
  configurationStatuses?: string[];
  // Tariff specific filters
  customerTypes?: string[];
  tariffStatuses?: string[];
  tariffNameSearch?: string;
}

export class TariffDataOut {
    id?: string;
    tariffClassName?: string | undefined;
    tariffRate?: string | undefined;
    customerType?: string | undefined;
    serviceType?: string | undefined;
    dateCreated?: Date | undefined;
    lastUpdated?: Date | undefined;
    status?: string | undefined;
    band?: string | undefined;
}
